import { Box, Button, Container, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: '16px',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
          p: { xs: 3, md: 6 },
        }}
      >
        <Button
          onClick={() => navigate(-1)}
          variant="text"
          size="small"
          sx={{ mb: 4, textTransform: 'none', fontWeight: 600 }}
        >
          &larr; Back
        </Button>

        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, color: 'text.primary' }}>
          Privacy Policy
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 4 }}>
          Last Updated: June 14, 2026
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              1. Information We Collect
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              When you use Minotii, we collect various types of information to provide and improve our services.
              Specifically, if you choose to sign in using Google Sign-In, we collect your Google profile information,
              which includes your name, email address, and language preferences.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              2. How We Use Your Information
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              We use the information we collect to operate, maintain, and provide the features and functionality of our platform,
              including:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography component="li" variant="body2" color="text.secondary">
                Creating your account and authenticating your login requests.
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                Verifying license access and tenant assignments.
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                Sending welcome emails and platform notifications.
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                Ensuring platform security and preventing fraud.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              3. Data Sharing and Disclosure
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties.
              This does not include trusted third parties who assist us in operating our website, conducting our business,
              or servicing you, so long as those parties agree to keep this information confidential. We may also release
              your information when we believe release is appropriate to comply with the law, enforce our site policies,
              or protect ours or others' rights, property, or safety.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              4. Data Retention and Safety
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              We secure your personal information from unauthorized access, use, or disclosure using industry-standard
              cryptographic protocols (such as SSL and JWT authorization tokens). We retain your data for as long as your
              account is active or as needed to provide you services. If you close your account, we will de-activate
              and delete your profile information in accordance with our system cleanup policies.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              5. Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              If you have any questions regarding this Privacy Policy, please feel free to reach out to us at
              contactus@minotii.com.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default PrivacyPolicyPage;
